module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	require('fox-dynamic-injection!fox-template-loader!../templates/copyright')(fox);

	fox.registerWidget('Copyright', {
		configure: function () {
			this.registerOptions('', {
				autoRender: true,
				startDate: 2013,
				container: '.cp-container',
				template: 'copyright'
			});
			
			this.callParent('configure', arguments);
		},

		rendering: function () {
			this.setTemplateOptions({
				startDate: this.getOption('startDate'),
				endDate: new Date().getFullYear()
			});

			this.callParent('rendering', arguments);
		}

	}, 'Widget');
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/publisher/widget/copyright.js
// module id = 140
// module chunks = 5